module.exports = __webpack_public_path__ + "static/selfie-photo-4cd571b922da7f0fb1ff1b784e8c530b.png";